// GA4 pageview tracking — guarded no-op until REACT_APP_GA4_MEASUREMENT_ID is set.
const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID;
const validId = typeof measurementId === "string" && /^G-[A-Z0-9]+$/i.test(measurementId);

let lastPageKey = null;

function initGA4() {
  if (!validId || typeof document === "undefined") return false;
  if (window.__ga4Configured) return true;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  if (!document.querySelector('script[data-ga4="true"]')) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
    script.dataset.ga4 = "true";
    document.head.appendChild(script);
  }

  window.gtag("js", new Date());
  // Router-driven pageviews only — automatic page_view disabled to avoid double-counting.
  window.gtag("config", measurementId, { send_page_view: false });
  window.__ga4Configured = true;
  return true;
}

export function trackPageView(pathname, search = "") {
  if (!initGA4() || typeof window === "undefined") return;

  const pageKey = `${pathname}${search}`;
  if (pageKey === lastPageKey) return;
  lastPageKey = pageKey;

  const url = new URL(window.location.href);
  url.pathname = pathname;
  url.search = search;
  url.hash = "";

  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: url.toString(),
    page_path: pageKey,
    debug_mode: process.env.NODE_ENV !== "production",
  });
}
